import { Box, Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Flex, Input, Text, useDisclosure } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-scroll";
import {GiHamburgerMenu} from "react-icons/gi"

const Navbar = () => {
   
  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = React.useRef()


  return (
    <>
    <Flex  pos={"fixed"} zIndex={3} w="100%" bg="rgb(34,83,200)" color="white" fontWeight={500} h="10vh" justifyContent={"space-between"} alignItems={"center"} p="0px 20px" >
      <Text fontSize={"20px"} _hover={{color:"black"}} cursor={"pointer"}>Portfolio</Text>
      <Flex display={["none","none","flex"]} cursor={"pointer"} justifyContent={"space-between"} w="600px" alignItems={"center"} >
        <Link
          to={"home"}
          activeClass="active"
          spy={true}
          smooth={true}
          offset={-80}
          duration={800}
        >
        <Text _hover={{color:"black"}} cursor="pointer" >  Home </Text>
        </Link>

        <Link
          to={"about"}
          activeClass="active"
          spy={true}
          smooth={true}
          offset={-60}
          duration={800}
        >
            <Text _hover={{color:"black"}} cursor="pointer" > About</Text>

         
        </Link>

        <Link
          to={"tools"}
          activeClass="active"
          spy={true}
          smooth={true}
          offset={-40}
          duration={800}
        >
            <Text _hover={{color:"black"}} cursor="pointer" >Tools</Text>

          
        </Link>

        <Link
          to={"project"}
          activeClass="active"
          spy={true}
          smooth={true}
          offset={-40}
          duration={800}
        >
            <Text _hover={{color:"black"}} cursor="pointer" > Project</Text>

         
        </Link>

        <Link
          to={"statistics"}
          activeClass="active"
          spy={true}
          smooth={true}
          offset={-40}
          duration={800}
        >
            <Text _hover={{color:"black"}} cursor="pointer" > Statistics</Text>

         
        </Link>

        <Link
          to={"contacts"}
          activeClass="active"
          spy={true}
          smooth={true}
          offset={0}
          duration={800}
        >
            <Text _hover={{color:"black"}} cursor="pointer" >Contacts</Text>
          
        </Link>
        <a href="https://drive.google.com/uc?id=1hP8mEK3N_a_Uwxj-or0hx91VipW7I1id&export=download" >
        <Button _hover={{bg:"white", color:"#2253c8"}} variant={"outline"}  >Resume</Button>
        </a>
       
      </Flex>
       <Box onClick={onOpen} cursor="pointer" display={["inline-block","inline-block","none"]}>
      <GiHamburgerMenu/>
      </Box>
    </Flex>
    <Box h="10vh"></Box>

    {/*  */}

    <Drawer
        isOpen={isOpen}
        placement='right'
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton color="white" />
          

          <DrawerBody display="flex" flexDir={"column"} fontSize="20px" fontWeight={600} alignItems={"center"} color="white" justifyContent={"space-evenly"}  bg={"#2253c8"} >
           
          <a href="https://drive.google.com/uc?id=1hP8mEK3N_a_Uwxj-or0hx91VipW7I1id&export=download" >
        <Button _hover={{bg:"white", color:"#2253c8"}} variant={"outline"} onClick={onClose} cursor="pointer" >Resume</Button>
        </a>

          <Link
          to={"home"}
          activeClass="active"
          spy={true}
          smooth={true}
          offset={-80}
          duration={800}
        >
        <Text onClick={onClose} _hover={{color:"black"}} cursor="pointer" >  Home </Text>
        </Link>

        <Link
          to={"about"}
          activeClass="active"
          spy={true}
          smooth={true}
          offset={-80}
          duration={800}
        >
            <Text onClick={onClose} _hover={{color:"black"}} cursor="pointer" > About</Text>

         
        </Link>

        <Link
          to={"tools"}
          activeClass="active"
          spy={true}
          smooth={true}
          offset={-80}
          duration={800}
          
        >
            <Text onClick={onClose} _hover={{color:"black"}} cursor="pointer" >Tools</Text>

          
        </Link>

        <Link
          to={"project"}
          activeClass="active"
          spy={true}
          smooth={true}
          offset={-80}
          duration={800}
        >
            <Text onClick={onClose} _hover={{color:"black"}} cursor="pointer" > Project</Text>

         
        </Link>

        <Link
          to={"statistics"}
          activeClass="active"
          spy={true}
          smooth={true}
          offset={-80}
          duration={800}
        >
            <Text onClick={onClose} _hover={{color:"black"}}  cursor="pointer" >  Statistics</Text>

         
        </Link>

        <Link
          to={"contacts"}
          activeClass="active"
          spy={true}
          smooth={true}
          offset={-80}
          duration={800}
        >
            <Text onClick={onClose}  _hover={{color:"black"}} cursor="pointer" >Contacts</Text>
          
        </Link>
         
       

          </DrawerBody>

         
        </DrawerContent>
      </Drawer>

    </>
  );
};

export default Navbar;
